import { render, staticRenderFns } from "./record-cp-table.vue?vue&type=template&id=5c613e60"
import script from "./record-cp-table.vue?vue&type=script&lang=js"
export * from "./record-cp-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports